import LegalLayout from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p>The VIN Verifier ("we", "us") respects your privacy. This policy explains what information we collect when you use our website or book a mobile VIN verification, and how we use it.</p>

      <h2>Information We Collect</h2>
      <p>When you submit our appointment or contact form, we collect the information you provide — such as your name, phone number, email address, vehicle details, city, and any message. This information is used solely to schedule and perform your VIN verification and to communicate with you about your request.</p>

      <h2>How We Use Your Information</h2>
      <p>We use your information to respond to inquiries, schedule appointments, complete your DMV REG 31 verification, and provide customer service. We do not sell or rent your personal information to third parties.</p>

      <h2>Free VIN Decoder</h2>
      <p>When you use our VIN decoder, your VIN is sent directly from your browser to the NHTSA vPIC service to retrieve vehicle specifications. The decoder does not save a VIN search history on our servers or in browser storage. NHTSA processes requests under its own privacy policy.</p>

      <h2>Data Retention</h2>
      <p>We retain appointment and contact records for as long as necessary to provide our services and to comply with legal and tax obligations. You may request deletion of your information by contacting us.</p>

      <h2>Cookies & Analytics</h2>
      <p>Our website may use basic cookies and analytics to understand how visitors use the site and to improve performance. You can disable cookies in your browser settings.</p>

      <h2>Your Rights</h2>
      <p>California residents may request access to, correction of, or deletion of their personal information. To make a request, contact us using the details below.</p>
    </LegalLayout>
  );
}
